import { stVars } from '../Foundation/stylable/spacing.st.css';
export var directions = {
  horizontal: 'horizontal',
  vertical: 'vertical'
};
export var horizontalAlignmentValues = {
  left: 'left',
  center: 'center',
  right: 'right',
  'space-between': 'space-between'
};
export var verticalAlignmentValues = {
  top: 'top',
  middle: 'middle',
  bottom: 'bottom',
  'space-between': 'space-between'
};
export var spacingValues = {
  tiny: "".concat(parseInt(stVars.Spacing), "px"),
  small: "".concat(parseInt(stVars.Spacing) * 2, "px"),
  medium: "".concat(parseInt(stVars.Spacing) * 3, "px"),
  large: "".concat(parseInt(stVars.Spacing) * 4, "px")
};